var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{attrs:{"id":"project-property-reports","rounded":""}},[_c('reports-table',{attrs:{"reports":_vm.reports}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }